import { createCustomSelector } from '../../domain/utils/react-reselect'
import { selectHasPoisOnRoute } from '../../store/itinerary/poisOnRoute.selectors'
import { PAGE_CLASSES } from '../pageClasses.constants'

export default createCustomSelector(selectHasPoisOnRoute, poisOnRoute => [poisOnRoute && PAGE_CLASSES.withPoisOnRoute])
